import React, { ReactElement } from 'react';
import CheckboxInternal from '@mui/material/Checkbox';
import FormatService from '../../services/format-service';
import useStylesCheckbox from './checkbox.styles';

const Checkbox: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isHeader,
    isLight,
    isChecked,
    isIndeterminate,
    isDisabled,
    withOffset,
    withNoPadding,
    className,
    id,
    onChange,
  } = props;

  const { classes } = useStylesCheckbox();

  const offsetClassName: string | undefined = withOffset ? classes.checkboxOffset : undefined;
  const noPaddingClassName: string | undefined = withNoPadding ? classes.checkboxNoPadding : undefined;
  const headerClassName: string | undefined = isHeader ? classes.checkboxHeader : undefined;
  const lightClassName: string | undefined = isLight ? classes.checkboxLight : undefined;

  return (
    <CheckboxInternal
      disabled={isDisabled}
      indeterminate={isIndeterminate}
      checked={isChecked}
      id={id}
      classes={{
        root: FormatService.formatClassNames(
          classes.checkbox, offsetClassName, noPaddingClassName, lightClassName, className,
        ),
        colorSecondary: headerClassName,
      }}
      onChange={onChange}
    />
  );
});

export default Checkbox;
